import { Injectable } from '@angular/core';
import { EndPoint } from '@constants/api.constant';
import { DEFAULT_PAGE_QUERY } from '@constants/settings.constant';
import { IResponse, Page } from '@models/common.model';
import {
  CreateFeedbackRequest,
  CreateFlashSaleRequest,
  Feedback,
  FeedbackSearchQuery,
  FlashSale,
  Product,
  ProductCategory,
  ProductDetail,
  ProductForm,
  ProductNutriShopSearchQuery,
  ProductQueryType,
  ProductSearchQuery,
} from '@models/product.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  public search(params: ProductSearchQuery, flashSale = false) {
    let url = `${EndPoint['searchProduct'].path}`;
    if (flashSale) {
      url = `${EndPoint['flashSale'].path}`;
    }
    return this.http.get<IResponse<Page<Product>>>(url, { params });
  }

  public searchNutriShopProduct(query: ProductNutriShopSearchQuery) {
    return this.http.get<IResponse<Page<Product>>>(
      `${EndPoint['nutrishopProduct'].path}`,
      { params: query }
    );
  }

  public getProductHomepage() {
    return this.http.get<
      IResponse<Record<keyof typeof ProductQueryType, Product[]>>
    >(`${EndPoint['homepage'].path}`);
  }

  public postFeedback(productId: number, request: CreateFeedbackRequest) {
    return this.http.post<IResponse<unknown>>(
      `${EndPoint['feedback'].path}/${productId}`,
      request
    );
  }

  public searchFeedback(productId: number, params: FeedbackSearchQuery) {
    return this.http.get<IResponse<Page<Feedback>>>(
      `${EndPoint['feedback'].path}/${productId}`,
      { params }
    );
  }

  public getProduct(productId: number) {
    return this.http.get<IResponse<ProductDetail>>(
      `${EndPoint['product'].path}/${productId}`
    );
  }

  public updateProduct(request: ProductForm) {
    return this.http.put<IResponse<unknown>>(
      `${EndPoint['createProduct'].path}/${request.id}`,
      request
    );
  }

  public createFlashSale(request: CreateFlashSaleRequest) {
    return this.http.post<IResponse<unknown>>(
      `${EndPoint['flashSale'].path}`,
      request
    );
  }
  public updateFlashSale(request: CreateFlashSaleRequest, productId: number) {
    return this.http.put<IResponse<unknown>>(
      `${EndPoint['flashSale'].path}/${productId}`,
      request
    );
  }

  public getProductFlashSale(productId: number) {
    return this.http.get<IResponse<FlashSale>>(
      `${EndPoint['flashSale'].path}/${productId}`
    );
  }

  public getProductCategories() {
    return this.http.get<IResponse<Page<ProductCategory>>>(
      `${EndPoint['productCategories'].path}`,
      {
        params: {
          ...DEFAULT_PAGE_QUERY,
          size: 9999,
        },
      }
    );
  }

  public getProductRelevant(productId: number, params: ProductSearchQuery) {
    return this.http.get<IResponse<Page<Product>>>(
      `${EndPoint['productRelevant'].path}/${productId}`,
      { params }
    );
  }

  public createProduct(request: ProductForm) {
    return this.http.post<IResponse<unknown>>(
      `${EndPoint['createProduct'].path}`,
      request
    );
  }
}
